import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from '@/app/App'
import { alErrorDeReact, iniciarSentry } from '@/lib/errores'
import './index.css'

iniciarSentry()

const contenedor = document.getElementById('root')
if (!contenedor) throw new Error('No se encontró el elemento #root')

createRoot(contenedor, {
  onUncaughtError: alErrorDeReact,
  onCaughtError: alErrorDeReact,
  onRecoverableError: alErrorDeReact,
}).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
